import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import useUserPermissions from "tools/validateAccess";

const PublicRoute = () => {
  const { token } = useSelector((state) => state.auth);
  const role = useSelector((state) => state.auth.role);
  const isNew = useSelector((state) => state.auth.isNew);

  const { getUserPermissionType } = useUserPermissions();
  const userPermissionType = getUserPermissionType();

  let indexOne = 0;
  if ((userPermissionType === "superadmin" || userPermissionType === "admin") && isNew !== 0) {
    indexOne = 1;
  } else if ((userPermissionType === "superadmin" || userPermissionType === "admin") && isNew === 0) {
    indexOne = 2;
  } else {
    indexOne = 0;
  }

  return token ? (
    <Navigate to={`${AUTHENTICATED_ENTRY[indexOne]}/`} />
  ) : (
    <Outlet />
  );
};

export default PublicRoute;
